export default __webpack_public_path__ + "static/media/message.71081f25.wav";